import { motion, AnimatePresence } from "framer-motion";
import { X, Smartphone } from "lucide-react";
import { FaGooglePlay, FaApple } from "react-icons/fa";

const ANDROID_URL = "https://play.google.com/store/apps/details?id=com.barakah.barakah.barakah&hl=en-US";
const IOS_URL = "https://apps.apple.com/us/app/%D9%85%D8%B2%D8%A7%D8%AF-%D8%A8%D8%B1%D9%83%D8%A9/id6476919358?l=ar";

const DownloadModal = ({ open, setOpen }) => {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
          onClick={() => setOpen(false)}
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", damping: 25 }}
            className="bg-white rounded-3xl p-8 max-w-sm w-full mx-4 shadow-2xl relative"
            onClick={(e) => e.stopPropagation()}
            dir="rtl"
          >
            <button
              onClick={() => setOpen(false)}
              className="absolute top-4 left-4 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <X className="w-6 h-6" />
            </button>

            <div className="text-center">
              <div className="w-16 h-16 bg-[#48B3BD] rounded-full flex items-center justify-center mx-auto mb-4">
                <Smartphone className="w-8 h-8 text-white" />
              </div>
              <h2 className="text-2xl font-bold text-gray-800 mb-2">
                حمّل التطبيق
              </h2>
              <p className="text-gray-600 mb-8 leading-relaxed text-sm">
                للمشاركة في المزادات والتفاعل مع جميع الميزات، حمّل تطبيق بركة
                زاد الآن
              </p>

              <div className="flex flex-col gap-4">
                <a
                  href={ANDROID_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-3 bg-black text-white rounded-xl py-3 px-6 hover:bg-gray-800 transition-all duration-200 hover:scale-105"
                >
                  <FaGooglePlay className="w-6 h-6 text-white" size={22} />
                  <div className="text-right">
                    <div className="text-xs opacity-70">متاح على</div>
                    <div className="font-bold text-sm">Google Play</div>
                  </div>
                </a>

                <a
                  href={IOS_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-3 bg-black text-white rounded-xl py-3 px-6 hover:bg-gray-800 transition-all duration-200 hover:scale-105"
                >
                  <FaApple className="text-white" size={24} />
                  <div className="text-right">
                    <div className="text-xs opacity-70">متاح على</div>
                    <div className="font-bold text-sm">App Store</div>
                  </div>
                </a>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DownloadModal;
